const scheduledServicesEventCardList = {
  servicesTitle: 'Serviços',
  servicesFilters: 'Filtros Serviços',
  showMoreButton: 'Mostrar mais',
  notFound: 'Nenhum serviço encontrado',
  assignMany: 'Atribuir Múltiplos',
  assignOne: 'Atribuir Um',
  selectAll: 'Selecionar Todos',
  clearAll: 'Limpar Todos',
};

export default scheduledServicesEventCardList;
